angular.module("app").directive("designerUseColorAcrossCategoriesChart", () => {
  let link = (scope) => {

  };

  return {
    restrict: "E",
    templateUrl: "app/directives/dbDesignerUseColorAcrossCategoriesChart/dbDesignerUseColorAcrossCategoriesChartView.html",
    link: link,
    scope: {
      data: "="
    }
  };
});
